<template>
  <vs-popup
    :active="localVisible"
    @close="$emit('close')"
    class="popup-extend"
    title="Verlängerung bestätigen"
  >
    <div>
      <p class="mt-2">
        Geben Sie an, um wie viele Jahre die ausgewählten Ausweise verlängert
        werden sollen:
      </p>

      <vs-input
        v-model.number="yearsToExtend"
        type="number"
        min="1"
        max="10"
        placeholder="z.B. 3"
        class="mt-4 mb-4"
      />

      <div class="mt-6">
        <p><strong>Ausgewählte Ausweise:</strong></p>
        <ul>
          <li v-for="card in idCards" :key="card.id">
            {{ card.person_last_name }}, {{ card.person_first_name }} – gültig
            bis {{ card.valid_until | moment("DD.MM.YYYY") }}
          </li>
        </ul>
      </div>
    </div>

    <div
      class="popup-footer"
      style="margin-top: 20px; display: flex; justify-content: flex-end; gap: 10px;"
    >
      <vs-button
        :disabled="!yearsToExtend || yearsToExtend < 1"
        @click="confirmExtend"
      >
        Verlängern
      </vs-button>
      <vs-button color="danger" @click="emitClose">Abbrechen</vs-button>
    </div>
  </vs-popup>
</template>

<script>
export default {
  props: {
    visible: { type: Boolean, required: true },
    idCards: { type: Array, required: true },
  },
  emits: ["close", "extended"],
  data() {
    return {
      yearsToExtend: null,
      localVisible: this.visible,
    };
  },
  watch: {
    visible(val) {
      this.localVisible = val;
      if (!val) this.yearsToExtend = null;
    },
    localVisible(val) {
      if (!val) this.emitClose();
    },
  },
  methods: {
    emitClose() {
      this.$emit("close");
    },
    async confirmExtend() {
      if (!this.yearsToExtend || this.yearsToExtend < 1) return;

      const results = [];

      for (const card of this.idCards) {
        try {
          const status = await this.$store.dispatch("idCard/extendIdCard", {
            idCard: card,
            yearsToExtend: this.yearsToExtend,
          });
          results.push({ id: card.id, status });
        } catch (error) {
          results.push({ id: card.id, status: 500 });
        }
      }

      const failed = results.filter(
        (r) => !(r.status >= 200 && r.status < 300)
      );

      if (failed.length === 0) {
        this.$vs.notify({
          color: "success",
          title: "Erfolg",
          text: "Alle Ausweise wurden verlängert.",
        });
      } else {
        this.$vs.notify({
          color: "warning",
          title: "Teilweise fehlgeschlagen",
          text: `${failed.length} von ${results.length} Ausweisen konnten nicht verlängert werden.`,
        });
      }

      this.$emit("extended");
      this.emitClose();
    },
  },
};
</script>

<style scoped>
.popup-extend {
  align-items: center;
  position: absolute;
}
</style>
